<div class="download-dialog">
  <h2 mat-dialog-title> Porta un amico in Beizy! </h2>
  
  <mat-dialog-content>
    <p>
      Se porti un amico in Beizy, lo renderai felice due volte: sia perchè sta per conoscere la velocità e la comodità di un <strong>vero Commercialista online,</strong> sia perchè avrete entrambi <strong>uno sconto!</strong>.
    </p>

    <!-- Check icon conditionally displayed -->
    <!-- <div class="check-icon-container" *ngIf="data.documentType"> -->
    <div class="success-container">
      <mat-icon class="success-icon mb-3" color="primary">diversity_1</mat-icon>
      <p class="success-message">Se lavori in compagnia, il risparmio di Beizy raddoppia!.</p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center">
    <button 
      mat-button 
      (click)="closeDialog()"
      class="close-button">
      Chiudi
    </button>
    
    <button 
      mat-raised-button 
      color="primary" 
      class="download-button"
      (click)="confirm()">
      Prosegui
      <mat-icon>arrow_circle_right</mat-icon>
    </button>
  </mat-dialog-actions>
</div>


